import currency_helpers from './currency';

export default {
  toggleGallery: (state, toggle = -1) => {
    state.product.gallery_active = (toggle == -1) ? !state.product.gallery_active : toggle;
  },
  toggleTab: (state, id) => {
    state.product.selected_tab = (state.product.selected_tab == id) ? false : id;
  },
  addQty: (state) => {
    var quantity = state.product.selected_quantity;
    state.product.selected_quantity = (quantity + 1 > 10) ? 10 : quantity + 1;
  },
  subQty: (state) => {
    var quantity = state.product.selected_quantity;
    state.product.selected_quantity = (quantity - 1 < 1) ? 1 : quantity - 1;
  },
  selectOption: (state, data, option,ov,ov_idx) => {
    //Update selected options
    var selected_options = state.product.selected_options;
    selected_options[option.type_index] = ov;
    state.product.selected_options = []; // Force refresh
    state.product.selected_options = selected_options;

    //Format selected options to match the way shopifies variant.options works
    var variant_options = [];
    _.each(state.product.selected_options, (ov, idx) => {
      variant_options[idx] = ov; 
    });

    //Attempt to find variant that the options match
    var selected_variant = _.find(data.product.variants, (v) => {
      var clean_options = _.map(v.options, (vo) => {return vo;});
      return _.isEqual(variant_options, clean_options);
    });

    //Update variant if one is found and not the same as old one
    if(selected_variant) {
      state.product.selected_variant = selected_variant;
    }
    console.log(selected_options);
  }
}